import Vue from 'vue'
import Vuex from 'vuex'
import {baseURL} from '@/general'
import axios from 'axios'
axios.defaults.baseURL = baseURL

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
